import { useEffect } from 'react';
/**
 * Gives you an empty collection of media devices.
 */
export function getEmptyMediaDevices() {
    return {
        hasAudio: false,
        audioDevices: [],
        audioDevicesById: {},
        hasVideo: false,
        videoDevices: [],
        videoDevicesById: {},
    };
}
/**
 * Retrieves the list of available media devices.
 */
export async function getMediaDevices() {
    try {
        const devices = await window.navigator.mediaDevices.enumerateDevices();
        const audioDevices = [];
        const audioDevicesById = {};
        const videoDevices = [];
        const videoDevicesById = {};
        let hasAudio = false;
        let hasVideo = false;
        for (const device of devices) {
            if (device.kind === 'audioinput') {
                hasAudio = true;
                if (device.deviceId) {
                    audioDevices.push(device);
                    audioDevicesById[device.deviceId] = device;
                }
            }
            if (device.kind === 'videoinput') {
                hasVideo = true;
                if (device.deviceId) {
                    videoDevices.push(device);
                    videoDevicesById[device.deviceId] = device;
                }
            }
        }
        return {
            hasAudio,
            audioDevices,
            audioDevicesById,
            hasVideo,
            videoDevices,
            videoDevicesById,
        };
    }
    catch (e) {
        console.warn('Failed to enumerate media devices', e);
    }
    return getEmptyMediaDevices();
}
/**
 * Starts, updates, and stops broadcaster's `MediaProducer`.
 */
export function useBroadcastUpdater({ broadcaster, enabled, mediaStream, }) {
    useEffect(function startMediaProducer() {
        if (!enabled ||
            mediaStream.getAudioTracks().length === 0 ||
            mediaStream.getVideoTracks().length === 0) {
            return () => { };
        }
        broadcaster?.startMediaProducer(mediaStream);
        return () => {
            broadcaster?.stopMediaProducer();
        };
    }, [broadcaster, mediaStream, enabled]);
}
